var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("stores")]),_vm._v("\n  "+_vm._s(_vm.all_stores)+"\n  "),_c('h2',[_vm._v("business types")]),_vm._v("\n  "+_vm._s(_vm.all_business_types)+"\n  "),_c('h2',[_vm._v("Available modules")]),_vm._v("\n  "+_vm._s(_vm.availableModules)+"\n  "),_c('h2',[_vm._v("Brands by filters")]),_c('h2',[_vm._v("brands by type")])])
}
var staticRenderFns = []

export { render, staticRenderFns }